module.exports = __webpack_public_path__ + "static/media/ua.90f3d547.png";